import api from './api';
import type { ApiResponse, AgentStatus, AgentStatusEntry } from '@/types';

export interface AgentAvailabilityResponse {
  user_id: number;
  extension: string;
  name: string;
  status: AgentStatus;
}

export const getMyAvailability = async (): Promise<AgentAvailabilityResponse> => {
  const response = await api.get<ApiResponse<AgentAvailabilityResponse>>('/agent-availability/my');
  return response.data.data;
};

export const updateMyAvailability = async (status: AgentStatus): Promise<AgentAvailabilityResponse> => {
  const response = await api.put<ApiResponse<AgentAvailabilityResponse>>('/agent-availability', { status });
  return response.data.data;
};

export const getAgentAvailabilities = async (): Promise<AgentStatusEntry[]> => {
  const response = await api.get<ApiResponse<AgentStatusEntry[]>>('/agent-availability');
  return response.data.data;
};
